import React, { Component } from "react";
import { displayAge} from "../../../helpers/Common.js"
class PendingPatientListItem extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { complain_type_id,
      coordinate_x,
      coordinate_y,
      created_at,
      date_of_birth,
      date_of_created,
      department_id,
      email,
      exported_file_path,
      first_name,
      gender,
      id,
      image_view,
      last_name,
      narrative_summary,
      patient_additional_info,
      phone,
      status,
      submitted_by_patient,
      complain_types,
      new_data,
      surgeon_id,
      title,
      updated_at,
      via_surgeon_id } = this.props.pendingPatientsData;
      
    return (
      <React.Fragment>
        <li onClick={this.props.handleAction.bind(this, id)} style={{cursor:'pointer'}}>
          <div className="row">
            <div className="col-md-1 col-sm-12">
            <div className="sypmtom-info">
                <div className="symptom-title">
                  <p>
                    {this.props.index+1}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-2 col-sm-12">
              <div className="sypmtom-info">
                <div className="symptom-title">
                  <p>
                    {first_name} {last_name}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-2 col-sm-12">
              <div className="symptom-title">
                {new_data  ? Object.values(new_data).map((row2, key2) => (
                    <p>{row2.complainType}</p>
                )):''}
              </div>
            </div>
            <div className="col-md-1 col-sm-12">
              <div className="symptom-title">
                <p>{gender}</p>
              </div>
            </div>
            <div className="col-md-1 col-sm-12">
              <div className="symptom-title">
                <p>{displayAge(date_of_birth)}</p>
              </div>
            </div>
            <div className="col-md-2 col-sm-12">
              <div className="symptom-title">
                <p>{date_of_created}</p>
              </div>
            </div>
            <div className="col-md-2 col-sm-12">
              <div className="symptom-title">
                <p>
                  { status==0 
                    ?
                      <img src={require(`../../../assets/img/icons/ic-waiting.png`)} alt="" /> 
                    : <img src={require(`../../../assets/img/icons/ic-complete-native.png`)} height="18" alt="" />
                  }
                  { status==1 
                    ?
                     ' Approved'
                    : ' Pending'
                  }
                  
                </p>
              </div>
            </div>
          </div>
        </li>
      </React.Fragment>
    );
  }
}

export default PendingPatientListItem;
